import { ActivityHistoryFilters } from '../../typings'
import { FetchAllActivityHistoryFilters } from './typings'

export const fetchAllActivityHistoryFiltersActionCreator = (
  payload: ActivityHistoryFilters,
): FetchAllActivityHistoryFilters => ({
  type: 'activityHistoryFilters/updateAll',
  payload,
})
